module.exports = __webpack_public_path__ + "media/images/icon-arrow-down-alternate-c0717e0132438a829fa04ec002936d92.svg";